import { type SEOHandle } from '@nasa-gcn/remix-seo'
import { GiftLanding } from '#app/components/gift-landing'

export const handle: SEOHandle = {
	getSitemapEntries: () => [{ route: '/gifts/anniversary' }],
}

export const meta = () => [
	{ title: 'Personalised Digital Anniversary Gifts | Erda' },
	{
		name: 'description',
		content:
			'Celebrate your anniversary with a meaningful place on the map. Gift a personal digital place and fund tree planting for $2 per place per year.',
	},
	{
		property: 'og:title',
		content: 'A digital anniversary gift with a place in your story | Erda',
	},
	{ property: 'og:url', content: 'https://erda.app/gifts/anniversary' },
	{ property: 'og:type', content: 'website' },
]

export default function AnniversaryGift() {
	return <GiftLanding occasion="anniversary" />
}
